import React from 'react';
var HeaderDropdownLink = function (props) {
    var text = props.text, _a = props.href, href = _a === void 0 ? '/' : _a, _b = props.target, target = _b === void 0 ? '_self' : _b;
    return (React.createElement("li", { className: "o-header-dropdown-menu-item" },
        React.createElement("a", { href: href, target: target }, text)));
};
export default React.memo(HeaderDropdownLink);
